import { filterEmptyLocalisedValues } from "@/app/core-module/util/coreHelper";

export const getTrainingModuleInput = trainingModule => {
  const input = {
    _id: trainingModule._id,
    displayPosition: trainingModule.displayPosition,
  };

  if (trainingModule.title) {
    const localisedTitles =
      filterEmptyLocalisedValues(trainingModule.title) ?? [];

    if (localisedTitles.length) input.title = localisedTitles;
  }

  if (trainingModule.description) {
    input.description =
      filterEmptyLocalisedValues(trainingModule.description) ?? [];
  }

  return input;
};
